import axios from "axios";
import i18n from "@/i18n";
import router from "@/router";
const config = require('@/config')
const deploy = {
    state: () => ({
        website: {
            subdomain: '',
            status: ''
        },
        websiteLoading: false,
        websiteDeployed: false,
        websiteWorking: true,
        domainNameChecking: false,
        domainNameAvailable: null,
        domainNameSelected: true,
        stopStatuses: ['unpublished', 'deployed', 'undeployed', 'deploy_error', 'undeploy_error', 'upgrade_error']
    }),
    getters: {
        WEBSITE(state) {return state.website},
        WEBSITE_WORKING(state) {return state.websiteWorking},
        WEBSITE_LOADING(state) {return state.websiteLoading},
        WEBSITE_DEPLOYED(state) {return state.websiteDeployed},
        DOMAIN_NAME_CHECKING(state) {return state.domainNameChecking},
        DOMAIN_NAME_AVAILABLE(state) {return state.domainNameAvailable},
        DOMAIN_NAME_SELECTED(state) {return state.domainNameSelected},
    },
    mutations: {
        setWebsite(state, payload) {
            state.website.subdomain = payload.restmonster_subdomain
            state.website.status = payload.status
            if (payload.status === 'deployed') {
                state.websiteDeployed = true
            } else {
                state.websiteDeployed = false
            }
        },
        setWebsiteWorking(state, status) {
            if (status === 200) {
                state.websiteWorking = true
            } else {
                state.websiteWorking = false
            }
        },
        setWebsiteLoading(state, payload) {
            state.websiteLoading = payload
        },
        setDomainNameChecking(state, payload) {
            state.domainNameChecking = payload
        },
        setDomainNameAvailable(state, payload) {
            state.domainNameAvailable = payload
        },
        setDomainNameSelected(state, payload) {
            state.domainNameSelected = payload
        },
        clearDomainName(state) {
            state.domainNameAvailable = null;
            state.selectedDomainName = '';
            state.domainNameSelected = false;
        },
    },
    actions: {
        async getWebsite({state, commit, dispatch, rootState}, restId) {
            await dispatch('tryAutoSignIn', null, { root: true })
            this.commit('setWebsiteLoading', true)
            let idToken = rootState.tokens.idToken
            // let companyId = rootState.company.id
            let axiosHeader = { headers: {"Authorization": idToken, "Content-Type": 'application/json'} }
            await axios.get(`${config.servUrl}admin/websites/${restId}`, axiosHeader)
              .then(response => {
                  this.commit('setWebsiteLoading', false)
                  this.commit('setWebsite', response.data)
                  // TODO: Включаем проверку домена
                  // if(response.data.status === 'deployed') {
                  //     dispatch('checkWebsiteWorking')
                  // }
                  let TrueRoute = router.currentRoute.value.name === 'RestDeploy' ? true : false // если мы находимся на странице деплоя
                  if (TrueRoute && !state.stopStatuses.includes(response.data.status)) {
                      setTimeout(() => dispatch('getWebsite', restId), 5000) //запускаем обновление статуса сайта
                  }

                  return true
              })
              .catch(error => {
                  console.log(error);
                  dispatch('addNewNotice', {text: error, error: true})
                  return false
              })
        },
        async checkWebsiteWorking({state, commit, dispatch, rootState}, ) {
            let url = 'https://' + state.website.subdomain + '.restmonster.ru'
            let xhr = new XMLHttpRequest();
            await xhr.open('get', url, false)
            try {
                xhr.send()
                this.commit('setWebsiteWorking', xhr.status)
            } catch (err) {

            }
            let TrueRoute = router.currentRoute.value.name === 'RestDeploy' ? true : false
            if (!state.websiteWorking && TrueRoute && state.websiteDeployed) {
                setTimeout(() => dispatch('checkWebsiteWorking'), 3000) //запускаем обновление статуса сайта
            }
        },
        async checkSubdomain({state, commit, dispatch, rootState}, domainName) {
            await dispatch('tryAutoSignIn', null, { root: true })
            this.commit('setDomainNameChecking', true)
            let idToken = rootState.tokens.idToken
            let body = {
                'restmonster_subdomain': domainName
            }
            let axiosHeader = { headers: {"Authorization": idToken, "Content-Type": 'application/json'} }
            await axios.post(`${config.servUrl}admin/websites/check-domain-availability`, body, axiosHeader)
              .then(response => {
                  this.commit('setDomainNameChecking', false) //имя перестает выбираться
                  if (response.data.available) {
                      this.commit('setDomainNameSelected', true) //имя выбрано
                  }
                  this.commit('setDomainNameAvailable', response.data.available)
              })
              .catch(error => {
                  console.log(error);
                  this.commit('setDomainNameChecking', false)
                  dispatch('addNewNotice', {text: error, error: true})
              })
        },
        async createWebsite({state, commit, dispatch, rootState}, payload) {
            await dispatch('tryAutoSignIn', null, { root: true })
            let idToken = rootState.tokens.idToken
            let body = {
                'restmonster_subdomain': payload.domainName
            }
            let axiosHeader = { headers: {"Authorization": idToken, "Content-Type": 'application/json'} }
            await axios.post(`${config.servUrl}admin/websites/${payload.restId}`, body, axiosHeader)
              .then(response => {
                  dispatch('getWebsite', payload.restId)
                  return true
              })
              .catch(error => {
                  console.log(error);
                  dispatch('addNewNotice', {text: error, error: true})
                  return false
              })
        },
        async upgradeWebsite({state, commit, dispatch, rootState}, restId) {
            await dispatch('tryAutoSignIn', null, { root: true })
            let idToken = rootState.tokens.idToken
            let axiosHeader = { headers: {"Authorization": idToken, "Content-Type": 'application/json'} }
            await axios.patch(`${config.servUrl}admin/websites/${restId}`, {}, axiosHeader)
                .then(response => {
                    dispatch('getWebsite', restId)
                })
                .catch(error => {
                    console.log(error);
                    dispatch('addNewNotice', {text: error, error: true})
                })
        },
        async undeployWebsite({state, commit, dispatch, rootState}, restId) {
            await dispatch('tryAutoSignIn', null, { root: true })
            let idToken = rootState.tokens.idToken
            let axiosHeader = { headers: {"Authorization": idToken, "Content-Type": 'application/json'} }
            await axios.post(`${config.servUrl}admin/websites/undeploy/${restId}`, {}, axiosHeader)
                .then(response => {
                    dispatch('getWebsite', restId)
                })
                .catch(error => {
                    console.log(error);
                    dispatch('addNewNotice', {text: error, error: true})
                })
        },
        async deleteWebsite({state, commit, dispatch, rootState}, restId) {
            await dispatch('tryAutoSignIn', null, { root: true })
            let idToken = rootState.tokens.idToken
            let axiosHeader = { headers: {"Authorization": idToken, "Content-Type": 'application/json'} }
            await axios.delete(`${config.servUrl}admin/websites/${restId}`, axiosHeader)
                .then(response => {
                    dispatch('getWebsite', restId)
                })
                .catch(error => {
                    console.log(error);
                    dispatch('addNewNotice', {text: error, error: true})
                })
        },
    }
}
export {deploy}
